const contentList = document.querySelectorAll('.faq-content'),
    optionMenu = document.querySelector(".select-menu"),
    selectBtn = optionMenu.querySelector(".select-btn"),
    options = optionMenu.querySelectorAll(".option"),
    sBtn_text = optionMenu.querySelector(".sBtn-text");

selectBtn.addEventListener("click", () => optionMenu.classList.toggle("active"));

options.forEach(option => {
    option.addEventListener("click", () => {
        let selectedOption = option.querySelector(".option-text").innerText;
        sBtn_text.innerText = selectedOption;
        optionMenu.classList.remove("active");
        if (selectedOption != "All") {
            for (let j = 0; j < contentList.length; j++) {
                contentList[j].classList.remove('selected');
                
            };
            const classStr = '.faq-' + selectedOption.toLowerCase();
            const selectedList = document.querySelectorAll(classStr);
            for (let i = 0; i < selectedList.length; i++) {
                selectedList[i].classList.add('selected');
               
            };
        } else {
            for (let j = 0; j < contentList.length; j++) {
                contentList[j].classList.add('selected');
               
            };
        }
    });
});
